import { css } from '@emotion/react'
import { memo, type ReactNode } from 'react'

import { spacing } from '../../foundations/spacing-tokens.ts'

type ButtonGroupProps = {
  children: ReactNode
  orientation?: 'column' | 'row'
  wrap?: boolean
  className?: string
}

export const ButtonGroup = memo<ButtonGroupProps>(function ButtonGroup(props) {
  const { children, orientation = 'row', wrap = false, className } = props

  return (
    <div
      css={css`
        display: flex;
        flex-flow: ${orientation} ${wrap ? 'wrap' : 'nowrap'};
        align-items: center;
        gap: ${spacing['30']};
      `}
      className={className}
    >
      {children}
    </div>
  )
})
